import { Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import {MaterialModule} from '@app/material.module';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';

@Component({
  selector: 'app-recovery-password-done',
  imports: [MaterialModule, TranslateModule, CommonModule],
  templateUrl: './recovery-password-done.component.html',
  standalone: true,
  styleUrl: './recovery-password-done.component.scss'
})
export class RecoveryPasswordDoneComponent {
  private router = inject(Router);

  goLogin(): void {
    this.router.navigate(['login']);
  }
}
